<template>
  <div class="home-games home-games-new all-content">
    <div class="home-games-left">
      <div v-if="auth" class="loading" :style="{width: progress + '%'}"></div>

      <div v-if="games" class="all-games-new">
        <LayoutNavAuth>
          <p class="img">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <g clip-path="url(#clip0_1926_24641)">
                <path d="M16.0796 6.56633C18.8738 8.28291 18.8738 12.5744 16.0796 14.291L8.53508 18.9257C5.74085 20.6423 2.24805 18.4966 2.24805 15.0635V5.79385C2.24805 2.36069 5.74086 0.21497 8.53508 1.93154L16.0796 6.56633Z" stroke="#01DF72" stroke-width="1.7"/>
                <path d="M8.53508 18.9257C5.74085 20.6423 2.24805 18.4966 2.24805 15.0635V5.79385C2.24805 2.36069 5.74086 0.21497 8.53508 1.93154L16.0796 6.56633" stroke="#026EED" stroke-width="1.7" stroke-linecap="round"/>
              </g>
              <defs>
                <clipPath id="clip0_1926_24641">
                  <rect width="20" height="20" fill="white" transform="translate(0.200195 0.440002)"/>
                </clipPath>
              </defs>
            </svg>
            {{__('Games')}}
          </p>
          <div slot="right" class="wrap-tabs">
            <tabs
                    :tabs="side_tabs"
                    :currentTab="currentTab"
                    :wrapper-class="'buttons-tabs'"
                    :tab-class="'buttons-tabs__item'"
                    :tab-active-class="'buttons-tabs__item_active'"
                    :line-class="'buttons-tabs__active-line'"
                    @onClick="sideChange"
            />
          </div>
        </LayoutNavAuth>

        <div v-if="currentTab === 'solo' || currentTab === 'all'">
          <div class="body-game all-content" v-if="games.solo_game && games.solo_game.length">
            <h6>{{__('SOLO GAMES')}}</h6>
            <ul>
              <li v-for="(item, key) in games.solo_game" :key="key" :item="item">
                <router-link
                        class="top-info"
                        :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"
                >
                  <div class="img">
                    <router-link
                            class="item-game__logo"
                            :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"
                            :style="(typeof item.logo == 'object') ? {background: 'url('+(item.logo[300])+') no-repeat 50%', backgroundSize: 'cover'} : {background: 'url('+(item.logo)+') no-repeat 50%', backgroundSize: 'cover'}"
                    >
                      <div class="reviews">
                        <!--                  <div class="rev" v-if="Number(item.rating).toFixed(2) >= 5.00">-->
                        <!--                    <img src="/dist/images/frontend/rev-5.svg" alt="">-->
                        <!--                    <p style="color: #01DF72">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 4.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-4-5.svg" alt="">-->
                        <!--                    <p style="color: #7FD926">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 4.00">-->
                        <!--                    <img src="/dist/images/frontend/rev-4.svg" alt="">-->
                        <!--                    <p style="color: #7FD926">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 3.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-3-5.svg" alt="">-->
                        <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 3.00">-->
                        <!--                    <img src="/dist/images/frontend/rev-3.svg" alt="">-->
                        <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 2.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-2-5.svg" alt="">-->
                        <!--                    <p style="color: #F2994A">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating) >= 2">-->
                        <!--                    <img src="/dist/images/frontend/rev-2.svg" alt="">-->
                        <!--                    <p style="color: #F2994A">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating) >= 1.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-1-5.svg" alt="">-->
                        <!--                    <p style="color: #EB5757">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating) >= 1">-->
                        <!--                    <img src="/dist/images/frontend/rev-1.svg" alt="">-->
                        <!--                    <p style="color: #EB5757">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="item.rating >= 0.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-0-5.svg" alt="">-->
                        <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else>-->
                        <!--                    <img src="/dist/images/frontend/rev-0.svg" alt="">-->
                        <!--                    <p style="color: rgba(150, 175, 209, 0.4);">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->

                        <!--                    <p>({{item.comment_count}} {{__('reviews')}})</p>-->
                      </div>
                    </router-link>
                  </div>
                  <div class="block-body">
                    <div class="name">
                      <router-link
                              class="top-info__title"
                              :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"

                      >
                        {{game_array(item).name}}
                      </router-link>
                      <!--              <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                      <!--                <path d="M0.0121107 0.944785H2.96541V0H11.6563V0.93047H14.624C14.624 0.93047 15.0049 5.9238 11.515 7.43432C11.3048 8.22856 10.8733 8.9476 10.2702 9.50858C9.66708 10.0696 8.91685 10.4497 8.10597 10.6051V12.4826H10.1499V14H4.5562V12.4826H6.57131V10.6154C5.75057 10.4692 4.98881 10.0931 4.37552 9.53128C3.76223 8.96948 3.32287 8.24528 3.10906 7.44376C-0.368171 5.92638 0.0121107 0.944785 0.0121107 0.944785ZM11.6563 5.62033C13.0298 4.57849 13.1187 2.47648 13.1187 2.47648H11.6563V5.62033ZM5.64609 7.01431L7.3241 6.1371L9.00212 7.01431L8.68143 5.15624L10.039 3.83926L8.16297 3.56814L7.3241 1.87898L6.48524 3.56957L4.60917 3.8407L5.96678 5.15767L5.64609 7.01431ZM2.96541 5.62376V2.4908H1.51711C1.51711 2.4908 1.60549 4.57849 2.96541 5.62376Z" fill="#FFC700"/>-->
                      <!--              </svg>-->
                    </div>

                    <!--                <div class="text">-->
                    <!--                  <p v-for="tag in item.tags" :key="tag">#{{tag}}</p>-->
                    <!--                </div>-->
                    <!--                <div class="stat">-->
                    <!--                  <div class="left">-->
                    <!--                    <div>-->
                    <!--                      <img src="/dist/images/frontend/light-coin.svg" alt="" class="pic">-->
                    <!--                      <p>1-100</p>-->
                    <!--                    </div>-->
                    <!--                    <div>-->
                    <!--                      <img src="/dist/images/frontend/money.svg" alt="" >-->
                    <!--                      <p>1-100</p>-->
                    <!--                    </div>-->
                    <!--                  </div>-->
                    <!--                  <div class="right">-->
                    <!--                    <svg width="10" height="10" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                    <!--                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.7288 6.90093C8.49561 8.06944 5.13943 10.0467 3.42243 10.6815C3.14839 10.7826 2.44975 10.9967 2.29919 10.9996C1.97948 11.0086 1.6716 10.851 1.52274 10.5982C1.46522 10.5001 1.29606 9.85938 1.24193 9.57394C1.08122 8.70573 0.998334 7.35734 1.00003 6.00151C0.998334 4.57878 1.08799 3.16646 1.2673 2.30717C1.31467 2.07525 1.45338 1.54155 1.49398 1.45532C1.5701 1.29476 1.70882 1.1684 1.87629 1.0896C2.00485 1.02865 2.15202 0.995943 2.29919 1.0004C2.44975 1.00338 3.06211 1.19218 3.27187 1.26503C4.92628 1.82996 8.42625 3.87857 9.71188 5.08276C9.82691 5.19128 10.1432 5.48267 10.1957 5.54213C10.3158 5.67593 10.375 5.83798 10.375 6.00151C10.375 6.15315 10.3226 6.30776 10.2143 6.4371C10.1585 6.504 9.83537 6.80133 9.7288 6.90093Z" stroke="#00AEFF" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>-->
                    <!--                    </svg>-->
                    <!--                    <p>{{item.match_online_count}}</p>-->
                    <!--&lt;!&ndash;                    <p v-else>{{item.user_online_count}}</p>&ndash;&gt;-->
                    <!--                  </div>-->
                    <!--                </div>-->
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="currentTab === 'ptp' || currentTab === 'all'">
          <div class="body-game all-content" v-if="games.games && games.games.data.length">
            <h6>{{__('P2P GAMES')}}</h6>
            <ul>
              <li v-for="(item, key) in games.games.data" :key="key" :item="item">
                <router-link
                        class="top-info"
                        :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"
                >
                  <div class="img">
                    <router-link
                            class="item-game__logo"
                            :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"
                            :style="(typeof item.logo == 'object') ? {background: 'url('+(item.logo[300])+') no-repeat 50%', backgroundSize: 'cover'} : {background: 'url('+(item.logo)+') no-repeat 50%', backgroundSize: 'cover'}"
                    >
                      <div class="reviews">
                        <div class="right">
                          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <path d="M8.38739 5.53564L8.38738 5.53563L8.38489 5.53799C7.81048 6.08227 6.70307 6.84559 5.50109 7.56183C4.30312 8.27569 3.06526 8.91075 2.24904 9.21252C2.12652 9.2577 1.89543 9.33282 1.6743 9.39742C1.56441 9.42952 1.46245 9.45742 1.38178 9.47699C1.30787 9.49492 1.27837 9.49906 1.27846 9.49979C1.27849 9.50005 1.28234 9.49988 1.28932 9.49974L1.28932 9.49972L1.28525 9.49984C1.13507 9.50402 1.01578 9.43202 0.963727 9.35999C0.95759 9.34328 0.949251 9.31876 0.938899 9.28606C0.917005 9.21689 0.890814 9.12605 0.863748 9.02589C0.809139 8.82382 0.757121 8.60675 0.733367 8.48181C0.581022 7.65797 0.498349 6.3456 0.500026 5.00213L0.500025 5.00091C0.498345 3.58753 0.588248 2.21683 0.756759 1.40931L0.756763 1.40931L0.757189 1.40722C0.778126 1.30471 0.821932 1.12368 0.866649 0.954109C0.888748 0.870309 0.909999 0.793386 0.927568 0.733974C0.941411 0.687163 0.948892 0.665541 0.950361 0.660577C0.971145 0.622883 1.01453 0.577137 1.08915 0.54203L1.08915 0.542032L1.09049 0.541398C1.15027 0.513055 1.21907 0.498205 1.28405 0.500174L1.28405 0.500185C1.28135 0.50012 1.27992 0.500098 1.2799 0.500232C1.27984 0.500805 1.30595 0.504245 1.37069 0.519475C1.44177 0.536196 1.53059 0.559991 1.62581 0.587231C1.81675 0.64185 2.01326 0.704509 2.10784 0.737356L2.10784 0.737362L2.1103 0.738202C2.888 1.00376 4.14122 1.63601 5.37604 2.36477C6.61174 3.09405 7.76824 3.88421 8.36934 4.44699C8.39864 4.47462 8.44333 4.51631 8.49272 4.56238C8.53901 4.60556 8.58943 4.65258 8.63513 4.69547C8.68468 4.74196 8.73089 4.78562 8.76739 4.82076C8.79581 4.84811 8.81133 4.86363 8.81766 4.86997C8.82089 4.87319 8.82173 4.87404 8.82067 4.87284L8.82066 4.87285L8.82361 4.87613C8.8617 4.91857 8.875 4.96179 8.875 5.00151C8.875 5.03716 8.86297 5.07784 8.83089 5.11616L8.83039 5.11676C8.83266 5.11404 8.83208 5.11463 8.82752 5.11929C8.82103 5.1259 8.80651 5.14073 8.78069 5.16592C8.74405 5.20167 8.6976 5.24586 8.64786 5.29268C8.58065 5.35595 8.51289 5.41892 8.4582 5.46974C8.43071 5.49528 8.40653 5.51775 8.38739 5.53564Z" fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <p>{{item.match_online_count}}</p>
                          <!--                    <p v-else>{{item.user_online_count}}</p>-->
                        </div>
                        <!--                  <div class="rev" v-if="Number(item.rating).toFixed(2) >= 5.00">-->
                        <!--                    <img src="/dist/images/frontend/rev-5.svg" alt="">-->
                        <!--                    <p style="color: #01DF72">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 4.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-4-5.svg" alt="">-->
                        <!--                    <p style="color: #7FD926">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 4.00">-->
                        <!--                    <img src="/dist/images/frontend/rev-4.svg" alt="">-->
                        <!--                    <p style="color: #7FD926">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 3.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-3-5.svg" alt="">-->
                        <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 3.00">-->
                        <!--                    <img src="/dist/images/frontend/rev-3.svg" alt="">-->
                        <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 2.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-2-5.svg" alt="">-->
                        <!--                    <p style="color: #F2994A">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating) >= 2">-->
                        <!--                    <img src="/dist/images/frontend/rev-2.svg" alt="">-->
                        <!--                    <p style="color: #F2994A">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating) >= 1.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-1-5.svg" alt="">-->
                        <!--                    <p style="color: #EB5757">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="Number(item.rating) >= 1">-->
                        <!--                    <img src="/dist/images/frontend/rev-1.svg" alt="">-->
                        <!--                    <p style="color: #EB5757">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else-if="item.rating >= 0.5">-->
                        <!--                    <img src="/dist/images/frontend/rev-0-5.svg" alt="">-->
                        <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->
                        <!--                  <div class="rev" v-else>-->
                        <!--                    <img src="/dist/images/frontend/rev-0.svg" alt="">-->
                        <!--                    <p style="color: rgba(150, 175, 209, 0.4);">{{Number(item.rating).toFixed(2)}}</p>-->
                        <!--                  </div>-->

                        <!--                  <p>({{item.comment_count}} {{__('reviews')}})</p>-->
                        <!--                </div>-->
                        <!--                <div class="text">-->
                        <!--                  <p v-for="tag in item.tags" :key="tag">#{{tag}}</p>-->
                        <!--                </div>-->
                        <!--                <div class="stat">-->
                        <!--                  <div class="left">-->
                        <!--                    <div>-->
                        <!--                      <img src="/dist/images/frontend/light-coin.svg" alt="" class="pic">-->
                        <!--                      <p>1-100</p>-->
                        <!--                    </div>-->
                        <!--                    <div>-->
                        <!--                      <img src="/dist/images/frontend/money.svg" alt="" >-->
                        <!--                      <p>1-100</p>-->
                        <!--                    </div>-->
                        <!--                  </div>-->

                      </div>
                    </router-link>
                  </div>
                  <div class="block-body">
                    <div class="name">
                      <router-link
                              class="top-info__title"
                              :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"

                      >
                        {{game_array(item).name}}
                      </router-link>
                      <!--              <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                      <!--                <path d="M0.0121107 0.944785H2.96541V0H11.6563V0.93047H14.624C14.624 0.93047 15.0049 5.9238 11.515 7.43432C11.3048 8.22856 10.8733 8.9476 10.2702 9.50858C9.66708 10.0696 8.91685 10.4497 8.10597 10.6051V12.4826H10.1499V14H4.5562V12.4826H6.57131V10.6154C5.75057 10.4692 4.98881 10.0931 4.37552 9.53128C3.76223 8.96948 3.32287 8.24528 3.10906 7.44376C-0.368171 5.92638 0.0121107 0.944785 0.0121107 0.944785ZM11.6563 5.62033C13.0298 4.57849 13.1187 2.47648 13.1187 2.47648H11.6563V5.62033ZM5.64609 7.01431L7.3241 6.1371L9.00212 7.01431L8.68143 5.15624L10.039 3.83926L8.16297 3.56814L7.3241 1.87898L6.48524 3.56957L4.60917 3.8407L5.96678 5.15767L5.64609 7.01431ZM2.96541 5.62376V2.4908H1.51711C1.51711 2.4908 1.60549 4.57849 2.96541 5.62376Z" fill="#FFC700"/>-->
                      <!--              </svg>-->
                    </div>

                  </div>
                </router-link>
              </li>
            </ul>
          </div>
          <div v-else class="block-empty-search">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M31.6336 0.365896C31.1455 -0.122291 30.354 -0.122291 29.8659 0.365896L26.3949 3.8369C23.4987 1.3554 19.8473 -0.000228509 15.9998 -0.000228509C11.726 -0.000228509 7.70808 1.66402 4.68601 4.68602C1.66395 7.70802 -0.000236139 11.726 -0.000236139 15.9998C-0.000236139 19.851 1.3542 23.4998 3.83626 26.3955L0.365889 29.8659C-0.122299 30.3541 -0.122299 31.1455 0.365889 31.6336C0.609951 31.8777 0.929826 31.9998 1.24976 31.9998C1.5697 31.9998 1.88958 31.8777 2.13364 31.6336L31.6336 2.13365C32.1218 1.64552 32.1218 0.854021 31.6336 0.365896ZM2.49976 15.9998C2.49976 8.55583 8.55583 2.49977 15.9998 2.49977C19.1803 2.49977 22.2017 3.59771 24.6208 5.61096L5.61089 24.6209C3.59726 22.2021 2.49976 19.1831 2.49976 15.9998ZM30.464 9.15165C31.4831 11.3006 31.9998 13.6046 31.9998 15.9998C31.9998 19.158 31.0623 22.2294 29.2889 24.882C29.0479 25.2425 28.652 25.4374 28.2486 25.4374C28.0098 25.4374 27.7684 25.3691 27.555 25.2265C26.981 24.8428 26.8268 24.0665 27.2105 23.4926C28.7082 21.2525 29.4998 18.6616 29.4998 15.9998C29.4998 13.978 29.0642 12.0344 28.2051 10.2229C27.9093 9.59915 28.1752 8.85365 28.799 8.55783C29.4228 8.2619 30.1682 8.5279 30.464 9.15165ZM24.7001 27.9772C25.0578 28.5676 24.8691 29.3363 24.2786 29.694C21.7883 31.2025 18.9256 31.9998 15.9998 31.9998C13.6567 31.9998 11.3983 31.5045 9.28733 30.5276C8.66083 30.2376 8.38795 29.4947 8.67789 28.8682C8.96783 28.2417 9.71076 27.969 10.3373 28.2588C12.1168 29.0822 14.022 29.4998 15.9998 29.4998C18.4688 29.4998 20.8837 28.8275 22.9834 27.5556C23.5738 27.1979 24.3425 27.3866 24.7001 27.9772Z" fill="#DFEAFC"/>
            </svg>

            <span>
            {{__('No games found for your request')}} <br>
            {{__('Try to change your request')}}
          </span>
          </div>
        </div>

        <div class="body-game all-content test-game" v-if="games.test_game && games.test_game.length">
          <h6>{{__('Test Games on platform')}}</h6>

          <ul>
            <li v-for="(item, key) in games.test_game" :key="key" :item="item">
              <router-link
                      class="top-info"
                      :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"
              >
                <div class="img">
                  <router-link
                          class="item-game__logo"
                          :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"
                          :style="(typeof item.logo == 'object') ? {background: 'url('+(item.logo[300])+') no-repeat 50%', backgroundSize: 'cover'} : {background: 'url('+(item.logo)+') no-repeat 50%', backgroundSize: 'cover'}"
                  >
                    <div class="reviews">
                      <!--                  <div class="rev" v-if="Number(item.rating).toFixed(2) >= 5.00">-->
                      <!--                    <img src="/dist/images/frontend/rev-5.svg" alt="">-->
                      <!--                    <p style="color: #01DF72">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 4.5">-->
                      <!--                    <img src="/dist/images/frontend/rev-4-5.svg" alt="">-->
                      <!--                    <p style="color: #7FD926">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 4.00">-->
                      <!--                    <img src="/dist/images/frontend/rev-4.svg" alt="">-->
                      <!--                    <p style="color: #7FD926">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 3.5">-->
                      <!--                    <img src="/dist/images/frontend/rev-3-5.svg" alt="">-->
                      <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 3.00">-->
                      <!--                    <img src="/dist/images/frontend/rev-3.svg" alt="">-->
                      <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="Number(item.rating).toFixed(2) >= 2.5">-->
                      <!--                    <img src="/dist/images/frontend/rev-2-5.svg" alt="">-->
                      <!--                    <p style="color: #F2994A">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="Number(item.rating) >= 2">-->
                      <!--                    <img src="/dist/images/frontend/rev-2.svg" alt="">-->
                      <!--                    <p style="color: #F2994A">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="Number(item.rating) >= 1.5">-->
                      <!--                    <img src="/dist/images/frontend/rev-1-5.svg" alt="">-->
                      <!--                    <p style="color: #EB5757">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="Number(item.rating) >= 1">-->
                      <!--                    <img src="/dist/images/frontend/rev-1.svg" alt="">-->
                      <!--                    <p style="color: #EB5757">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else-if="item.rating >= 0.5">-->
                      <!--                    <img src="/dist/images/frontend/rev-0-5.svg" alt="">-->
                      <!--                    <p style="color: #F2C94C">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->
                      <!--                  <div class="rev" v-else>-->
                      <!--                    <img src="/dist/images/frontend/rev-0.svg" alt="">-->
                      <!--                    <p style="color: rgba(150, 175, 209, 0.4);">{{Number(item.rating).toFixed(2)}}</p>-->
                      <!--                  </div>-->

                      <!--                    <p>({{item.comment_count}} {{__('reviews')}})</p>-->
                    </div>
                  </router-link>
                </div>
                <div class="block-body">
                  <div class="name">
                    <router-link
                            class="top-info__title"
                            :to="{name: 'game', params: {'id': item.url, lang: $store.getters.getLang}}"

                    >
                      {{game_array(item).name}}
                    </router-link>
                    <!--              <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                    <!--                <path d="M0.0121107 0.944785H2.96541V0H11.6563V0.93047H14.624C14.624 0.93047 15.0049 5.9238 11.515 7.43432C11.3048 8.22856 10.8733 8.9476 10.2702 9.50858C9.66708 10.0696 8.91685 10.4497 8.10597 10.6051V12.4826H10.1499V14H4.5562V12.4826H6.57131V10.6154C5.75057 10.4692 4.98881 10.0931 4.37552 9.53128C3.76223 8.96948 3.32287 8.24528 3.10906 7.44376C-0.368171 5.92638 0.0121107 0.944785 0.0121107 0.944785ZM11.6563 5.62033C13.0298 4.57849 13.1187 2.47648 13.1187 2.47648H11.6563V5.62033ZM5.64609 7.01431L7.3241 6.1371L9.00212 7.01431L8.68143 5.15624L10.039 3.83926L8.16297 3.56814L7.3241 1.87898L6.48524 3.56957L4.60917 3.8407L5.96678 5.15767L5.64609 7.01431ZM2.96541 5.62376V2.4908H1.51711C1.51711 2.4908 1.60549 4.57849 2.96541 5.62376Z" fill="#FFC700"/>-->
                    <!--              </svg>-->
                  </div>

                  <!--                <div class="text">-->
                  <!--                  <p v-for="tag in item.tags" :key="tag">#{{tag}}</p>-->
                  <!--                </div>-->
                  <!--                <div class="stat">-->
                  <!--                  <div class="left">-->
                  <!--                    <div>-->
                  <!--                      <img src="/dist/images/frontend/light-coin.svg" alt="" class="pic">-->
                  <!--                      <p>1-100</p>-->
                  <!--                    </div>-->
                  <!--                    <div>-->
                  <!--                      <img src="/dist/images/frontend/money.svg" alt="" >-->
                  <!--                      <p>1-100</p>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <div class="right">-->
                  <!--                    <svg width="10" height="10" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                  <!--                      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.7288 6.90093C8.49561 8.06944 5.13943 10.0467 3.42243 10.6815C3.14839 10.7826 2.44975 10.9967 2.29919 10.9996C1.97948 11.0086 1.6716 10.851 1.52274 10.5982C1.46522 10.5001 1.29606 9.85938 1.24193 9.57394C1.08122 8.70573 0.998334 7.35734 1.00003 6.00151C0.998334 4.57878 1.08799 3.16646 1.2673 2.30717C1.31467 2.07525 1.45338 1.54155 1.49398 1.45532C1.5701 1.29476 1.70882 1.1684 1.87629 1.0896C2.00485 1.02865 2.15202 0.995943 2.29919 1.0004C2.44975 1.00338 3.06211 1.19218 3.27187 1.26503C4.92628 1.82996 8.42625 3.87857 9.71188 5.08276C9.82691 5.19128 10.1432 5.48267 10.1957 5.54213C10.3158 5.67593 10.375 5.83798 10.375 6.00151C10.375 6.15315 10.3226 6.30776 10.2143 6.4371C10.1585 6.504 9.83537 6.80133 9.7288 6.90093Z" stroke="#00AEFF" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>-->
                  <!--                    </svg>-->
                  <!--                    <p>{{item.match_online_count}}</p>-->
                  <!--&lt;!&ndash;                    <p v-else>{{item.user_online_count}}</p>&ndash;&gt;-->
                  <!--                  </div>-->
                  <!--                </div>-->
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="page-games-skeleton">
        <div class="top">
          <SkeletonImage></SkeletonImage>
          <SkeletonImage></SkeletonImage>
          <SkeletonImage></SkeletonImage>
        </div>

        <div class="dashboard-content">
          <div class="tabs">
            <SkeletonText :count="2" class="text"></SkeletonText>
          </div>

          <div class="list">
            <div class="item">
              <SkeletonImage></SkeletonImage>
              <SkeletonText :count="6" class="text"></SkeletonText>
            </div>

            <div class="item">
              <SkeletonImage></SkeletonImage>
              <SkeletonText :count="6" class="text"></SkeletonText>
            </div>

            <div class="item">
              <SkeletonImage></SkeletonImage>
              <SkeletonText :count="6" class="text"></SkeletonText>
            </div>

            <div class="item">
              <SkeletonImage></SkeletonImage>
              <SkeletonText :count="6" class="text"></SkeletonText>
            </div>

            <div class="item">
              <SkeletonImage></SkeletonImage>
              <SkeletonText :count="6" class="text"></SkeletonText>
            </div>

            <div class="item">
              <SkeletonImage></SkeletonImage>
              <SkeletonText :count="6" class="text"></SkeletonText>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-games-right">
      <GeneralChatNew></GeneralChatNew>
    </div>


  </div>
</template>

<script>
// import VueSlickCarousel from "vue-slick-carousel";
// import "vue-slick-carousel/dist/vue-slick-carousel.css";
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import InputLabelTextDefault from "../modules/InputLabelTextDefault";
import LayoutNavAuth from "../modules/LayoutNavAuth";
import SkeletonImage from "../modules/SkeletonImage";
import SkeletonText from "../modules/SkeletonText";
// import ItemUpcomingTournaments from "./Tournaments/ItemUpcomingTournaments";
import GeneralChatNew from "../modules/GeneralChatNew";
export default {
  name: "GamesHome",
  data() {
    return {
      currentTab: 'all',
      progress: 0,
      items: [],
      request: [],
      activeIndex: 0,
      games: null,
      side_tabs: [
        {
          title: "Все",
          value: "all",
        },
        {
          title: "SOLO",
          value: "solo",
        },
        {
          title: "P2P",
          value: "ptp",
        },
      ],
      settings: {
        "infinite": true,
        "arrows": true,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "autoplay": true,
        "speed": 2000,
        "autoplaySpeed": 5000,
        "responsive": [
          {
            "breakpoint": 950,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "initialSlide": 0
            }
          },
        ]
      },
      tournament_upcoming: null
    };
  },

  watch: {
    request() {
      this.getGames();
    }
  },
  methods:{
    sideChange(tab) {
      this.currentTab = tab; // обновляем текущую вкладку при изменении
    },
    handleClick(index) {
      this.items[index].isActive = !this.items[index].isActive;

      if (index == this.activeIndex) {
        this.items.forEach(item => {
          item.isActive = false;
        })

        this.items[0].isActive = true;
        this.activeIndex = 0;
        this.request = [];
      }

      if (index !== this.activeIndex) {
        this.items[this.activeIndex].isActive = false;
        this.request = [];
        this.items.forEach(item => {
          if (item.isActive) {
            this.request.push(item.title);
          }
        })
      }

      if (this.items.every(item => !item.isActive)) {
        this.items[0].isActive = true;
        this.activeIndex = 0;
        this.request = [];
      }


    },
    getGames() {
      let timeout = setInterval(() => {
        this.progress += 1;
        if(this.progress > 50) {
          clearInterval(timeout)
        }
      },15);

      let category = this.request;

      let request = {
        category: (category && category.length) ? category : null
      };
      
      this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']("ajax/games", request)
        .then((response) => {
          return response.json();
        })
        .then ((response) => {
          if(this.$checkAuth(response)) {
            this.games = response.data;
            this.tournament_upcoming = response.data.tournament_upcoming;

            if (window.innerWidth > 950) {
              if (response.data.tournament_upcoming && response.data.tournament_upcoming.length > 1) {
                this.settings.slidesToShow = 1
              } else {
                this.settings.slidesToShow = 1
              }
            }

            if (this.items && !this.items.length) {
              let category = [
                {
                  title: 'All',
                  isActive: true
                }
              ];
              response.data.category.forEach(item => {
                category.push({
                  title: item,
                  isActive: false
                })
              });
              this.items = category;
            }
            this.next_page_url = response.data.games.next_page_url;
            clearInterval(timeout);
            this.progress = 100;
            setTimeout(() => {
              this.progress = 0;
            }, 500);
          }
        })
        .catch((err) => {
          this.httpHandler(err);
        });
    },
    game_array(item) {
      if (this.$filterArray(item.game_translations, this.lang, 'lang')) {
        return this.$filterArray(item.game_translations, this.lang, 'lang');
      } else {
        return this.$filterArray(item.game_translations, 'en', 'lang');
      }
    },

  },
  computed: {

    auth() {
      return this.$store.state.auth.user;
    },
    lang() {
      return this.$store.state.language.lang;
    },
  },

  created() {
    this.getGames();
  },
  mounted() {

  },
    components: {
      LayoutNavAuth,
      GeneralChatNew,
      // VueSlickCarousel,
      SkeletonImage,
      SkeletonText,
      // ItemUpcomingTournaments
    }
}

</script>

<style lang="scss" scoped>
.home-games{
  color: #fff;
}


</style>